// hooks/usePermission.js
import { useSelector } from "react-redux";
import { selectPermissions } from "../store/selectors/authSelectors";

export const usePermission = (permission) => {
  const permissions = useSelector(selectPermissions);
  return permissions.includes(permission);
};